"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ratingSvgPaths = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var ratingSvgPaths = {
  '0': /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M72,1 L74.163,5.27865405 L79,5.96898002 L75.5,9.29758149 L76.326,14 L72,11.778654 L67.674,14 L68.5,9.29758149 L65,5.96898002 L69.837,5.27865405 L72,1 Z M56,1 L58.163,5.27865405 L63,5.96898002 L59.5,9.29758149 L60.326,14 L56,11.778654 L51.674,14 L52.5,9.29758149 L49,5.96898002 L53.837,5.27865405 L56,1 Z M40,1 L42.163,5.27865405 L47,5.96898002 L43.5,9.29758149 L44.326,14 L40,11.778654 L35.674,14 L36.5,9.29758149 L33,5.96898002 L37.837,5.27865405 L40,1 Z M24,1 L26.163,5.27865405 L31,5.96898002 L27.5,9.29758149 L28.326,14 L24,11.778654 L19.674,14 L20.5,9.29758149 L17,5.96898002 L21.837,5.27865405 L24,1 Z M8,1 L10.163,5.27865405 L15,5.96898002 L11.5,9.29758149 L12.326,14 L8,11.778654 L3.674,14 L4.5,9.29758149 L1,5.96898002 L5.837,5.27865405 L8,1 Z",
    id: "path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "atom/rating/0",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#EFE9D7",
    xlinkHref: "#path-1"
  }))),
  '0.5': /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M71,0 L73.163,4.27865405 L78,4.96898002 L74.5,8.29758149 L75.326,13 L71,10.778654 L66.674,13 L67.5,8.29758149 L64,4.96898002 L68.837,4.27865405 L71,0 Z M55,0 L57.163,4.27865405 L62,4.96898002 L58.5,8.29758149 L59.326,13 L55,10.778654 L50.674,13 L51.5,8.29758149 L48,4.96898002 L52.837,4.27865405 L55,0 Z M39,0 L41.163,4.27865405 L46,4.96898002 L42.5,8.29758149 L43.326,13 L39,10.778654 L34.674,13 L35.5,8.29758149 L32,4.96898002 L36.837,4.27865405 L39,0 Z M23,0 L25.163,4.27865405 L30,4.96898002 L26.5,8.29758149 L27.326,13 L23,10.778654 L18.674,13 L19.5,8.29758149 L16,4.96898002 L20.837,4.27865405 L23,0 Z M7,0 L9.163,4.27865405 L14,4.96898002 L10.5,8.29758149 L11.326,13 L7,10.778654 L2.674,13 L3.5,8.29758149 L0,4.96898002 L4.837,4.27865405 L7,0 Z",
    id: "path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "atom/rating/0.5",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#EFE9D7",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FCB643",
    mask: "url(#mask-2)",
    x: "0",
    y: "-1",
    width: "7",
    height: "16"
  })))),
  '1': /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M71,0 L73.163,4.27865405 L78,4.96898002 L74.5,8.29758149 L75.326,13 L71,10.778654 L66.674,13 L67.5,8.29758149 L64,4.96898002 L68.837,4.27865405 L71,0 Z M55,0 L57.163,4.27865405 L62,4.96898002 L58.5,8.29758149 L59.326,13 L55,10.778654 L50.674,13 L51.5,8.29758149 L48,4.96898002 L52.837,4.27865405 L55,0 Z M39,0 L41.163,4.27865405 L46,4.96898002 L42.5,8.29758149 L43.326,13 L39,10.778654 L34.674,13 L35.5,8.29758149 L32,4.96898002 L36.837,4.27865405 L39,0 Z M23,0 L25.163,4.27865405 L30,4.96898002 L26.5,8.29758149 L27.326,13 L23,10.778654 L18.674,13 L19.5,8.29758149 L16,4.96898002 L20.837,4.27865405 L23,0 Z M7,0 L9.163,4.27865405 L14,4.96898002 L10.5,8.29758149 L11.326,13 L7,10.778654 L2.674,13 L3.5,8.29758149 L0,4.96898002 L4.837,4.27865405 L7,0 Z",
    id: "path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "atom/rating/1.0",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#EFE9D7",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FCB643",
    mask: "url(#mask-2)",
    x: "0",
    y: "-1",
    width: "16",
    height: "16"
  })))),
  '1.5': /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M71,0 L73.163,4.27865405 L78,4.96898002 L74.5,8.29758149 L75.326,13 L71,10.778654 L66.674,13 L67.5,8.29758149 L64,4.96898002 L68.837,4.27865405 L71,0 Z M55,0 L57.163,4.27865405 L62,4.96898002 L58.5,8.29758149 L59.326,13 L55,10.778654 L50.674,13 L51.5,8.29758149 L48,4.96898002 L52.837,4.27865405 L55,0 Z M39,0 L41.163,4.27865405 L46,4.96898002 L42.5,8.29758149 L43.326,13 L39,10.778654 L34.674,13 L35.5,8.29758149 L32,4.96898002 L36.837,4.27865405 L39,0 Z M23,0 L25.163,4.27865405 L30,4.96898002 L26.5,8.29758149 L27.326,13 L23,10.778654 L18.674,13 L19.5,8.29758149 L16,4.96898002 L20.837,4.27865405 L23,0 Z M7,0 L9.163,4.27865405 L14,4.96898002 L10.5,8.29758149 L11.326,13 L7,10.778654 L2.674,13 L3.5,8.29758149 L0,4.96898002 L4.837,4.27865405 L7,0 Z",
    id: "path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "atom/rating/1.5",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#EFE9D7",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FCB643",
    mask: "url(#mask-2)",
    x: "0",
    y: "-1",
    width: "23",
    height: "16"
  })))),
  '2': /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M71,0 L73.163,4.27865405 L78,4.96898002 L74.5,8.29758149 L75.326,13 L71,10.778654 L66.674,13 L67.5,8.29758149 L64,4.96898002 L68.837,4.27865405 L71,0 Z M55,0 L57.163,4.27865405 L62,4.96898002 L58.5,8.29758149 L59.326,13 L55,10.778654 L50.674,13 L51.5,8.29758149 L48,4.96898002 L52.837,4.27865405 L55,0 Z M39,0 L41.163,4.27865405 L46,4.96898002 L42.5,8.29758149 L43.326,13 L39,10.778654 L34.674,13 L35.5,8.29758149 L32,4.96898002 L36.837,4.27865405 L39,0 Z M23,0 L25.163,4.27865405 L30,4.96898002 L26.5,8.29758149 L27.326,13 L23,10.778654 L18.674,13 L19.5,8.29758149 L16,4.96898002 L20.837,4.27865405 L23,0 Z M7,0 L9.163,4.27865405 L14,4.96898002 L10.5,8.29758149 L11.326,13 L7,10.778654 L2.674,13 L3.5,8.29758149 L0,4.96898002 L4.837,4.27865405 L7,0 Z",
    id: "path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "atom/rating/2.0",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#EFE9D7",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FCB643",
    mask: "url(#mask-2)",
    x: "0",
    y: "-1",
    width: "32",
    height: "16"
  })))),
  '2.5': /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M71,0 L73.163,4.27865405 L78,4.96898002 L74.5,8.29758149 L75.326,13 L71,10.778654 L66.674,13 L67.5,8.29758149 L64,4.96898002 L68.837,4.27865405 L71,0 Z M55,0 L57.163,4.27865405 L62,4.96898002 L58.5,8.29758149 L59.326,13 L55,10.778654 L50.674,13 L51.5,8.29758149 L48,4.96898002 L52.837,4.27865405 L55,0 Z M39,0 L41.163,4.27865405 L46,4.96898002 L42.5,8.29758149 L43.326,13 L39,10.778654 L34.674,13 L35.5,8.29758149 L32,4.96898002 L36.837,4.27865405 L39,0 Z M23,0 L25.163,4.27865405 L30,4.96898002 L26.5,8.29758149 L27.326,13 L23,10.778654 L18.674,13 L19.5,8.29758149 L16,4.96898002 L20.837,4.27865405 L23,0 Z M7,0 L9.163,4.27865405 L14,4.96898002 L10.5,8.29758149 L11.326,13 L7,10.778654 L2.674,13 L3.5,8.29758149 L0,4.96898002 L4.837,4.27865405 L7,0 Z",
    id: "path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "atom/rating/2.5",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#EFE9D7",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FCB643",
    mask: "url(#mask-2)",
    x: "0",
    y: "-1",
    width: "39",
    height: "16"
  })))),
  '3': /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M71,0 L73.163,4.27865405 L78,4.96898002 L74.5,8.29758149 L75.326,13 L71,10.778654 L66.674,13 L67.5,8.29758149 L64,4.96898002 L68.837,4.27865405 L71,0 Z M55,0 L57.163,4.27865405 L62,4.96898002 L58.5,8.29758149 L59.326,13 L55,10.778654 L50.674,13 L51.5,8.29758149 L48,4.96898002 L52.837,4.27865405 L55,0 Z M39,0 L41.163,4.27865405 L46,4.96898002 L42.5,8.29758149 L43.326,13 L39,10.778654 L34.674,13 L35.5,8.29758149 L32,4.96898002 L36.837,4.27865405 L39,0 Z M23,0 L25.163,4.27865405 L30,4.96898002 L26.5,8.29758149 L27.326,13 L23,10.778654 L18.674,13 L19.5,8.29758149 L16,4.96898002 L20.837,4.27865405 L23,0 Z M7,0 L9.163,4.27865405 L14,4.96898002 L10.5,8.29758149 L11.326,13 L7,10.778654 L2.674,13 L3.5,8.29758149 L0,4.96898002 L4.837,4.27865405 L7,0 Z",
    id: "path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "atom/rating/3.0",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#EFE9D7",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FCB643",
    mask: "url(#mask-2)",
    x: "0",
    y: "-1",
    width: "47",
    height: "16"
  })))),
  '3.5': /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M71,0 L73.163,4.27865405 L78,4.96898002 L74.5,8.29758149 L75.326,13 L71,10.778654 L66.674,13 L67.5,8.29758149 L64,4.96898002 L68.837,4.27865405 L71,0 Z M55,0 L57.163,4.27865405 L62,4.96898002 L58.5,8.29758149 L59.326,13 L55,10.778654 L50.674,13 L51.5,8.29758149 L48,4.96898002 L52.837,4.27865405 L55,0 Z M39,0 L41.163,4.27865405 L46,4.96898002 L42.5,8.29758149 L43.326,13 L39,10.778654 L34.674,13 L35.5,8.29758149 L32,4.96898002 L36.837,4.27865405 L39,0 Z M23,0 L25.163,4.27865405 L30,4.96898002 L26.5,8.29758149 L27.326,13 L23,10.778654 L18.674,13 L19.5,8.29758149 L16,4.96898002 L20.837,4.27865405 L23,0 Z M7,0 L9.163,4.27865405 L14,4.96898002 L10.5,8.29758149 L11.326,13 L7,10.778654 L2.674,13 L3.5,8.29758149 L0,4.96898002 L4.837,4.27865405 L7,0 Z",
    id: "path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "atom/rating/3.5",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#EFE9D7",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FCB643",
    mask: "url(#mask-2)",
    x: "0",
    y: "-1",
    width: "55",
    height: "16"
  })))),
  '4': /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M71,0 L73.163,4.27865405 L78,4.96898002 L74.5,8.29758149 L75.326,13 L71,10.778654 L66.674,13 L67.5,8.29758149 L64,4.96898002 L68.837,4.27865405 L71,0 Z M55,0 L57.163,4.27865405 L62,4.96898002 L58.5,8.29758149 L59.326,13 L55,10.778654 L50.674,13 L51.5,8.29758149 L48,4.96898002 L52.837,4.27865405 L55,0 Z M39,0 L41.163,4.27865405 L46,4.96898002 L42.5,8.29758149 L43.326,13 L39,10.778654 L34.674,13 L35.5,8.29758149 L32,4.96898002 L36.837,4.27865405 L39,0 Z M23,0 L25.163,4.27865405 L30,4.96898002 L26.5,8.29758149 L27.326,13 L23,10.778654 L18.674,13 L19.5,8.29758149 L16,4.96898002 L20.837,4.27865405 L23,0 Z M7,0 L9.163,4.27865405 L14,4.96898002 L10.5,8.29758149 L11.326,13 L7,10.778654 L2.674,13 L3.5,8.29758149 L0,4.96898002 L4.837,4.27865405 L7,0 Z",
    id: "path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "atom/rating/4.0",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#EFE9D7",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FCB643",
    mask: "url(#mask-2)",
    x: "0",
    y: "-1",
    width: "63",
    height: "16"
  })))),
  '4.5': /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M71,0 L73.163,4.27865405 L78,4.96898002 L74.5,8.29758149 L75.326,13 L71,10.778654 L66.674,13 L67.5,8.29758149 L64,4.96898002 L68.837,4.27865405 L71,0 Z M55,0 L57.163,4.27865405 L62,4.96898002 L58.5,8.29758149 L59.326,13 L55,10.778654 L50.674,13 L51.5,8.29758149 L48,4.96898002 L52.837,4.27865405 L55,0 Z M39,0 L41.163,4.27865405 L46,4.96898002 L42.5,8.29758149 L43.326,13 L39,10.778654 L34.674,13 L35.5,8.29758149 L32,4.96898002 L36.837,4.27865405 L39,0 Z M23,0 L25.163,4.27865405 L30,4.96898002 L26.5,8.29758149 L27.326,13 L23,10.778654 L18.674,13 L19.5,8.29758149 L16,4.96898002 L20.837,4.27865405 L23,0 Z M7,0 L9.163,4.27865405 L14,4.96898002 L10.5,8.29758149 L11.326,13 L7,10.778654 L2.674,13 L3.5,8.29758149 L0,4.96898002 L4.837,4.27865405 L7,0 Z",
    id: "path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "atom/rating/4.5",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#EFE9D7",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FCB643",
    mask: "url(#mask-2)",
    x: "0",
    y: "-1",
    width: "71",
    height: "16"
  })))),
  '5': /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M71,0 L73.163,4.27865405 L78,4.96898002 L74.5,8.29758149 L75.326,13 L71,10.778654 L66.674,13 L67.5,8.29758149 L64,4.96898002 L68.837,4.27865405 L71,0 Z M55,0 L57.163,4.27865405 L62,4.96898002 L58.5,8.29758149 L59.326,13 L55,10.778654 L50.674,13 L51.5,8.29758149 L48,4.96898002 L52.837,4.27865405 L55,0 Z M39,0 L41.163,4.27865405 L46,4.96898002 L42.5,8.29758149 L43.326,13 L39,10.778654 L34.674,13 L35.5,8.29758149 L32,4.96898002 L36.837,4.27865405 L39,0 Z M23,0 L25.163,4.27865405 L30,4.96898002 L26.5,8.29758149 L27.326,13 L23,10.778654 L18.674,13 L19.5,8.29758149 L16,4.96898002 L20.837,4.27865405 L23,0 Z M7,0 L9.163,4.27865405 L14,4.96898002 L10.5,8.29758149 L11.326,13 L7,10.778654 L2.674,13 L3.5,8.29758149 L0,4.96898002 L4.837,4.27865405 L7,0 Z",
    id: "path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "atom/rating/5.0",
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#EFE9D7",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FCB643",
    mask: "url(#mask-2)",
    x: "0",
    y: "-1",
    width: "78",
    height: "16"
  }))))
};
exports.ratingSvgPaths = ratingSvgPaths;